import { resourceText } from 'src/app/shared/services/localization';
import {
  AfterContentInit,
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { GlobalService } from 'src/app/shared/services/global.service';
import { TenantService } from 'src/app/tenant/tenant.service';
import { AuthService } from '../auth.service';
import { Capacitor } from '@capacitor/core';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit, AfterViewInit {
  isLoading: boolean = true;
  error: string = null;
  returnUrl: string;
  failureClosed: boolean = true;
  firstTime: boolean = false;
  agreementLink: string = '';
  churchName: string = '';
  churchLogo = '';
  emailVerification = false;
  tenantSubdomain = '';
  churchHomeUrl = '/home';
  myemail: string = '';
  isLogging: boolean = false;
  mypassword: string = '';
  fullName: string = '';
  workflow: boolean = false;
  termsAccepted: boolean = false;
  overrideMembership: number = 0;
  user: string = '';
  password: string = '';
  @ViewChild('myForm', { static: true }) myForm: NgForm;

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    public globalService: GlobalService,
    private _tenantService: TenantService
  ) { }
  async ngOnInit() {


    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    if (this.returnUrl == null)
      this.returnUrl = "";

    var tenantData = await this._tenantService.getSimpleTenant();
    if (tenantData.deleted == true) {
      this.router.navigate(['/service-notfound']);
      return;
    }
    this.churchName = tenantData.name;
    this.emailVerification = tenantData.accountVerificationMethod === "email";
    this.tenantSubdomain = this._tenantService.getTenant();
    this.churchHomeUrl = '/' + this._tenantService.getTenant() + '/home';
    this._tenantService.getTenantSmallLogo(this._tenantService.getTenant()).then(logo => this.churchLogo = logo).catch(() => {});
    this.isLoading = false;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.globalService.selectedOption = "";           
      this.globalService.title.push(this.globalService.screenHeader);
      if (this.firstTime == false)
        this.globalService.screenHeader = this.globalService.Get("LOGINPROG");
      else
        this.globalService.screenHeader = this.globalService.Get("CHURCHSERVICES");
    });
  }


  SetAsMembers() {
    this.isLoading = true;
    this.authService.login(this.user, this.password, true, 1).then(
      (data) => {
        if (data.statusCode == 200) {
          this.error = null;
          this.router.navigateByUrl(this.returnUrl);
        }
        else {
          this.isLoading = false;
          this.error = data.statusMessage;
        }
      }
    );
  }

  SetAsGuests() {
    this.isLoading = true;
    this.authService.login(this.user, this.password, true, 2).then(
      (data) => {
        if (data.statusCode == 200) {
          this.error = null;
          this.router.navigateByUrl(this.returnUrl);
        } 
        else {
          this.isLoading = false;
          this.error = data.statusMessage;
        }
      }
    );
  }

  Profile() {
    this.isLoading = true;
    this.authService
      .login(this.user, this.password, true, this.overrideMembership)
      .then(
        (data) => {
          if (data.statusCode == 200) {
            this.error = null;
            this.router.navigateByUrl(this.returnUrl);
          }
          else {
            this.isLoading = false;
            this.error = data.statusMessage;
          }
        }
      );
  }

  AcceptAgreement() {
    this.termsAccepted = !this.termsAccepted;
  }

  onSubmit(form: NgForm) {
    if (this.isLogging === true) {
      return;
    }

    if (!form.valid) {
      return;
    }

    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/home';
    if (this.returnUrl == null)
      this.returnUrl = "";

    if (form.value.username.indexOf('@') >= 0)
      this.user = form.value.username;
    else
      this.user = form.value.username.replace(/\D/g, "");
    if (this.user === '')
      this.user = form.value.username;
    this.password = form.value.password;
    this.isLogging = true;
    //  setTimeout(() => { formEl.submit() });
    this.authService.login(this.user, this.password, false, 0).then(
      (data) => {
        if (data == null) {
          this.isLogging = false;
          this.error = resourceText('UNABLE_TO_SIGN_IN_RIGHT_NOW_PLEASE_CHECK_YOUR_CONNECTION_AND_TRY_AGAIN');
          this.failureClosed = false;
          return false;
        }
        if (data.statusCode === 200) {
          this.isLogging = false;
          this.error = null;
          setTimeout(() => {
            this.router.navigateByUrl(this.returnUrl);
          }, 100);
          return true;
        }
        else {
          this.isLogging = false;
          if (
            data.statusMessage == 'FIRST_LOGIN' ||
            data.statusMessage == 'AGREEMENT_NEEDED'
          ) {
            this.isLoading = false;
            this.firstTime = data.statusMessage == 'FIRST_LOGIN';
            this.agreementLink = data.link;
            this.churchName = data.churchName;
            this.fullName = data.userName;
            this.workflow = data.workflow;
            this.overrideMembership = data.defaultMembership;
            if (this.agreementLink == '') this.termsAccepted = true;
          } else {
            this.isLoading = false;
            this.error = data.statusMessage;
            this.failureClosed = false;
          }
          return false;
        }
      }
    );
  }

}
